import styled from "styled-components";

export { Form, InputGroup, SubmitButton } from "../CadastroFormStyles.ts";

export const Notificacao = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
  color: ${({ theme }) => theme.colors.text};
`;
